import axios from 'axios';
import { pick } from 'lodash';

import { get, post, patch } from 'helpers/api';

const rootPath = '/contacts/companies';

export function fetchCompany(id) {
  return get(`${rootPath}/${id}`).then(response => response.company);
}

export function searchCompanies(searchTerm, databaseId, onSuccess) {
  axios
    .get(`${rootPath}/quick_search.json`, { params: {
      'q[search_text]': searchTerm,
      'q[database_id]': databaseId
    } })
    .then(function (response) {
      onSuccess(response.data.companies || []);
    });
}

export function createCompany(company, address = null) {
  const contactsCompany = buildCompanyParams(company, address);
  return post(`${rootPath}.json`, { contactsCompany }).then(data => data.company);
}

export function updateCompany(company, address = null) {
  const contactsCompany = buildCompanyParams(company, address);
  return patch(`${rootPath}/${company.id}.json`, { contactsCompany }).then(data => data.company);
}

const buildCompanyParams = (company, address) => {
  const contactsCompany = pick(company, 'name', 'email', 'phoneNumber', 'databaseId', 'projectId');

  if (address) {
    contactsCompany.addressesAttributes = [address];
  }

  return contactsCompany;
};
